import { render } from "./SpacesGroupsYouAreIn.vue?vue&type=template&id=141c63e8&scoped=true&ts=true"
import script from "./SpacesGroupsYouAreIn.vue?vue&type=script&lang=ts"
export * from "./SpacesGroupsYouAreIn.vue?vue&type=script&lang=ts"

import "./SpacesGroupsYouAreIn.vue?vue&type=style&index=0&id=141c63e8&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141c63e8"]])

export default __exports__